import * as React from "react";
import {Fragment} from "react";
import Navigation from "./Navigation/Navigation";
import Pane from "./Navigation/Pane";
import KeySolver from "../../KeySolver";
import "../../../node_modules/bootstrap/dist/js/bootstrap.bundle";
import Input from "./Input/Input";

class Main extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		const {children, shortcut} = this.props;

		return (
			<Fragment>
				<div className="container my-5">
					<div className="row">
						<div className="col-md-10 mx-auto">

							<div className="d-flex justify-content-center">
								<div className="d-inline-block mx-auto nav-pills-wrapper">
									<ul className="nav nav-pills justify-content-center" role="tablist">
										<Navigation items={children} />
									</ul>
								</div>
							</div>

							<div className="tab-content" >
								{children &&
									<Fragment>
										{children.map((item, i) =>
											<Fragment key={KeySolver()} >
												<Pane id={`item_${item.identifier}`} iterator={i} selected={parseInt(i) === 0} >
													{item.children.length > 0 &&
														<Fragment>
															<div className="row">
																{item.children.map((input, i) =>
																	<Fragment key={KeySolver()} >
																		<Input input={input} shortcut={shortcut} />
																	</Fragment>
																)}
															</div>
														</Fragment>
													}
												</Pane>
											</Fragment>
										)}
									</Fragment>
								}
							</div>

						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

export default Main;
